export const getLoadingState = state => state.ui.loading;
export const getFormSubmittingState = state => state.ui.isFormSubmittng;